<template>
  <AkPill
    v-if="hasWalletBalance"
    :content="$root.formatPrice(wallet.balance_amount, '$0,0')"
    :color="AkPillColor.Accent"
    :text-color="AkPillColor.AccentAlt"
  />
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import { AkPill, AkPillColor } from '@ankorstore/design-system';

export default defineComponent({
  name: 'BadgeWalletBalance',
  components: {
    AkPill,
  },
  data() {
    return {
      AkPillColor,
    };
  },
  computed: {
    ...mapState('wallet', ['wallet']),
    ...mapGetters('wallet', ['hasWalletBalance']),
  },
  created() {
    this.fetchWalletBalance();
  },
  methods: {
    ...mapActions('wallet', ['fetchWalletBalance']),
  },
});
</script>
